import { alpha } from '@mui/material';

import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

const getLockedBorder = userColor =>
  userColor ? `1px solid ${userColor}` : ({ palette }) => `1px solid ${palette.warning.main}`;

// The "Needed" field-highlight (DEV-4383). The deep PURPLE[7] accent + PURPLE[1]
// tint are tuned for a LIGHT backdrop; in dark mode the solid light-lavender fill
// rendered as a bright box with dark text (DEV-4566), so the accent lifts to a
// lighter purple and the fill becomes a low-alpha purple over the dark surface —
// mirroring the FieldCompletenessIndicator badge treatment (DEV-4501).
const NEEDED_DARK_TINT_ALPHA = 0.16;

const getNeededAccent = palette =>
  palette.mode === 'dark' ? COLOR_PALETTE.PURPLE[4] : COLOR_PALETTE.PURPLE[7];

const getNeededTint = palette =>
  palette.mode === 'dark'
    ? alpha(COLOR_PALETTE.PURPLE[4], NEEDED_DARK_TINT_ALPHA)
    : COLOR_PALETTE.PURPLE[1];

export const getWrapperStyles = ({
  isLockedByAnotherUser = false,
  userColor,
  columns = 1,
  wrapperStyles,
  isFieldNeeded = false,
} = {}) => ({
  position: 'relative',
  width: '100%',
  boxSizing: 'border-box',
  borderRadius: '4px',
  padding: '4px',
  gridColumn: columns > 1 ? `span ${columns}` : 'auto',
  border: isLockedByAnotherUser ? getLockedBorder(userColor) : '1px solid transparent',
  ...getConditionalObject(isLockedByAnotherUser, {
    opacity: 0.7,
    pointerEvents: 'none',
  }),
  ...getConditionalObject(isFieldNeeded, {
    borderLeft: ({ palette }) => `2px solid ${getNeededAccent(palette)}`,
    backgroundColor: ({ palette }) => getNeededTint(palette),
  }),
  ...wrapperStyles,
});

export const authorDotsIndicatorStyles = {
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  top: '-6px',
  left: '8px',
  zIndex: 1,
  padding: '0 2px',
  borderRadius: '4px',
  backgroundColor: ({ palette }) => palette.background.paper,
};
